var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 170 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-194.558,-280.815)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.731544,48.1934,98.9978)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.364,
    y: 279.242,
    width: 169.845,
    height: 22.863
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,86.5958,41.3973)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.189989,-3.19807)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 193.074,
    cy: 273.439,
    r: 30.823
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2269,0,0,1.2269,-45.9323,-68.4929)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 194.651,
    cy: 276.09,
    r: 13.222,
    style: {
      fill: "white"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.796ed4ce.svg";
export { ForwardRef as ReactComponent };